webpackJsonp([111848116438363],{

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/grand-mere.d7f48820.png";

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-family: \'Courier New\', Courier, monospace;\n  font-size: 32px;\n'], ['\n  font-family: \'Courier New\', Courier, monospace;\n  font-size: 32px;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-family: \'Courier New\', Courier, monospace;\n  font-size: 12px;\n'], ['\n  font-family: \'Courier New\', Courier, monospace;\n  font-size: 12px;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  background: url(', ') no-repeat;\n'], ['\n  background: url(', ') no-repeat;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(77);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactIntl = __webpack_require__(75);
	
	__webpack_require__(414);
	
	var _Layout = __webpack_require__(23);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _grandMere = __webpack_require__(557);
	
	var _grandMere2 = _interopRequireDefault(_grandMere);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var BanoiTitle = _styledComponents2.default.span(_templateObject);
	var Legend = _styledComponents2.default.span(_templateObject2);
	var Image = _styledComponents2.default.div(_templateObject3, _grandMere2.default);
	
	var Story = function (_React$Component) {
	  _inherits(Story, _React$Component);
	
	  function Story() {
	    _classCallCheck(this, Story);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Story.prototype.render = function render() {
	    return _react2.default.createElement(
	      _Layout2.default,
	      { locale: this.props.pathContext.locale },
	      _react2.default.createElement(
	        'div',
	        { className: 'row no-gutters pb-3 story-page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 col-lg-5 col-xl-4 pr-0 pr-lg-5' },
	          _react2.default.createElement(
	            BanoiTitle,
	            null,
	            '[Ba\u0300 n\u1ECD\u0302i]'
	          ),
	          _react2.default.createElement(
	            Legend,
	            null,
	            'n.f'
	          ),
	          _react2.default.createElement(
	            'h6',
	            { className: 'text-uppercase mb-4 title-translation' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'storyFrom' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'courier-new story' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'L\u2019histoire de Banoi c\u2019est celle de My-Ly Pham, ou plus particulie\u0300rement de sa grand-me\u0300re.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'D\u2019origine vietnamienne, My-Ly a depuis son enfance fait de nombreux voyages en Asie pour retrouver sa famille. Au fil de ces voyages et aux co\u0302te\u0301s de Banoi, elle a de\u0301couvert la gastronomie d\u2019Asie du Sud-Est, qu\u2019elle a eu rapidement envie de faire partager.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Alors de\u0301cide\u0301e a\u0300 cre\u0301er un restaurant, elle a multiplie\u0301 les voyages et s\u2019est inspire\u0301e des cuisines locales pour concevoir a\u0300 son tour des recettes originales : les cafe\u0301s de Bangkok, la sauce cacahue\u0300te de Birmanie, la soupe coco de Thai\u0308lande, et bien d\u2019autres clins d\u2019\u0153il a\u0300 l\u2019Asie composent aujourd\u2019hui ses recettes.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Mais la spe\u0301cialite\u0301 de Banoi, c\u2019est le rouleau de printemps. Il y est servit en plat, comme au Vietnam. On le de\u0301guste seul, accompagne\u0301 d\u2019une soupe coco, de bouche\u0301es de banh-mi ou me\u0302me d\u2019un verre de vin blanc.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Chez Banoi tout est pre\u0301pare\u0301 sur place, avec nos petites mains et les le\u0301gumes du marche\u0301 voisin. Des rouleaux aux desserts nos recettes sont toutes faites maison et se de\u0301clinent au gre\u0301 de nos inspirations.'
	            )
	          )
	        ),
	        _react2.default.createElement(Image, { className: 'col-12 col-lg-7 col-xl-8 mt-4 mt-sm-0 img-right' })
	      )
	    );
	  };
	
	  return Story;
	}(_react2.default.Component);
	
	exports.default = Story;
	module.exports = exports['default'];

/***/ }),

/***/ 414:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-story-js-ea5500000bb71199a130.js